// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-profile-modal .ant-modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.edit-profile-modal__form {
  padding: 10px 0;
}

.edit-profile-modal__form-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 16px;
  margin-bottom: 0;
}

.edit-profile-modal__form-item {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  margin-bottom: 16px;
}

.form-section-title {
  font-weight: 600;
  font-size: 14px;
  color: #262626;
  margin-bottom: 12px;
  margin-top: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.form-section-title:first-child {
  margin-top: 0;
}

/* Responsive adjustments */

@media (max-width: 768px) {
  .edit-profile-modal__form-row {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 0;
  }

  .edit-profile-modal__form-item {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./pages/edit-profile/edit-profile.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;;AAC3B;EACE;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".edit-profile-modal .ant-modal-body {\r\n  max-height: 70vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.edit-profile-modal__form {\r\n  padding: 10px 0;\r\n}\r\n\r\n.edit-profile-modal__form-row {\r\n  display: flex;\r\n  gap: 16px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.edit-profile-modal__form-item {\r\n  flex: 1;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.form-section-title {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #262626;\r\n  margin-bottom: 12px;\r\n  margin-top: 16px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.form-section-title:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .edit-profile-modal__form-row {\r\n    flex-direction: column;\r\n    gap: 0;\r\n  }\r\n\r\n  .edit-profile-modal__form-item {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
